import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height", "viewBox", "fill"]
const _hoisted_2 = ["fill"]
const _hoisted_3 = ["fill"]
const _hoisted_4 = ["fill"]

import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'closeBoxIcon',
  props: {
  color: {
    type: String as PropType<string>,
    default: "#DBDBDB",
  },
  colorX: {
    type: String as PropType<string>,
    default: "white",
  },
  size: {
    type: Number as PropType<number>,
    default: 14,
  },
  svgClass: {
    type: String as PropType<string>,
    default: "",
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: __props.size,
    height: __props.size,
    viewBox: `0 0 ${__props.size} ${__props.size}`,
    fill: __props.color,
    class: _normalizeClass(__props.svgClass),
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    _createElementVNode("rect", {
      id: "close-iten",
      width: "14",
      height: "14",
      rx: "7",
      fill: __props.color
    }, null, 8, _hoisted_2),
    _createElementVNode("rect", {
      x: "9.33203",
      y: "4",
      width: "0.942758",
      height: "7.54206",
      transform: "rotate(45 9.33203 4)",
      fill: __props.colorX
    }, null, 8, _hoisted_3),
    _createElementVNode("rect", {
      x: "4",
      y: "4.66748",
      width: "0.942758",
      height: "7.54206",
      transform: "rotate(-45 4 4.66748)",
      fill: __props.colorX
    }, null, 8, _hoisted_4)
  ], 10, _hoisted_1))
}
}

})